export enum PhotoDesign {
  REALISTIC = 'realistic',
  ANIMATED = 'animated',
  GEOMETRIC = 'geometric',
}
